import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { RECENT_BILLS_STATUSES } from '_constants/billing';
import { theme } from '_constants/theme';
import { formatPrice } from '_helpers/common';
import { hexToRGBA } from '_helpers/theme';

import Indicator from 'components/shared/Indicator';
import Text from 'components/shared/layouts/Text';

const StyledContainer = styled.div`
  width: 100%;
  padding: ${theme.spaces.regular}px;
  border-radius: 4px;
  border: 1px solid ${hexToRGBA(theme.colors.gray.secondary, 0.16)};
`;

const StyledLinkContainer = styled.div`
  margin-bottom: ${theme.spaces.regular}px;

  a {
    font-family: 'RethinkSans';
    font-size: ${theme.fontSizes.regular}px;
    font-weight: 400;
    line-height: 16px;
    color: ${theme.colors.cyanBlue};

    &:hover {
      color: ${theme.colors.cyanBlue};
    }
  }
`;

const StyledPaymentStatusContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  margin-bottom: ${theme.spaces.regular}px;
`;

const BillCard = ({
  orderId,
  crmOrderId,
  mainPaymentStatus,
  mainPaymentDate,
  totalPrice,
  totalRefunded,
  totalChargeback,
  totalAmount,
}) => (
  <StyledContainer>
    <Text size={theme.fontSizes.smallX} weight={600} color={theme.colors.gray.secondary}>
      ORDER ID
    </Text>
    <StyledLinkContainer>
      <Link to={`../order/${orderId}`}>{crmOrderId}</Link>
    </StyledLinkContainer>
    <Text size={theme.fontSizes.smallX} weight={600} color={theme.colors.gray.secondary}>
      PAYMENT STATUS
    </Text>
    <StyledPaymentStatusContainer>
      <Indicator status={mainPaymentStatus} />
      <Text>{RECENT_BILLS_STATUSES[mainPaymentStatus] || mainPaymentStatus}</Text>
    </StyledPaymentStatusContainer>
    <Text size={theme.fontSizes.smallX} weight={600} color={theme.colors.gray.secondary}>
      PAYMENT DATE
    </Text>
    <Text bottomSpace={theme.spaces.regular}>
      {mainPaymentDate && !mainPaymentDate?.includes('null') ? format(parseISO(mainPaymentDate), 'MMMM dd, yyyy') : '-'}
    </Text>
    <Text size={theme.fontSizes.smallX} weight={600} color={theme.colors.gray.secondary}>
      PRICE
    </Text>
    <Text bottomSpace={theme.spaces.regular}>{formatPrice(totalPrice)}</Text>
    <Text size={theme.fontSizes.smallX} weight={600} color={theme.colors.gray.secondary}>
      REFUNDED
    </Text>
    <Text bottomSpace={theme.spaces.regular}>{formatPrice(totalRefunded)}</Text>
    <Text size={theme.fontSizes.smallX} weight={600} color={theme.colors.gray.secondary}>
      CHARGEBACK
    </Text>
    <Text bottomSpace={theme.spaces.regular}>{formatPrice(totalChargeback)}</Text>
    <Text size={theme.fontSizes.smallX} weight={600} color={theme.colors.gray.secondary}>
      TOTAL AMOUNT
    </Text>
    <Text>{formatPrice(totalAmount)}</Text>
  </StyledContainer>
);

BillCard.propTypes = {
  orderId: PropTypes.string,
  crmOrderId: PropTypes.string,
  mainPaymentStatus: PropTypes.string,
  mainPaymentDate: PropTypes.string,
  totalPrice: PropTypes.number,
  totalRefunded: PropTypes.number,
  totalChargeback: PropTypes.number,
  totalAmount: PropTypes.number,
};

export default BillCard;
